module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "c04"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("INTERMEZZO #2")])]), _vm._v(" "), _c('div', {
    staticClass: "cst"
  }, [_c('b', [_vm._v("What Do All the Words Mean?")])]), _vm._v(" "), _c('div', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("I")]), _vm._v(" want to define two key words that tend to get “lost in translation”: philanthropy and fund development.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Let’s start with philanthropy. My favorite definition is “voluntary action for the common good.” Robert L. Payton, first professor of philanthropics in the United States, coined this. People give time and money to make things better in their communities. Serving as a board member, for instance, is philanthropy. So is making a financial gift.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Philanthropy is all about dreaming. Through philanthropy, we change communities. As Lee Kaiser says, “I love philanthropy because it allows me to substitute realities. Philanthropy is the motor that drives social change.”"), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c04_r1#en11",
      "id": "Ref-en11"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Philanthropy is a transformational act for donors, nonprofits, and the communities served by both. These transformational gifts have a “unique capacity to alter the programs, perceptions, and future of an organization.”"), _c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c04_r1#en12",
      "id": "Ref-en12"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("When it comes to the “f ” word, Tom and I wish people would use “fund development” rather than “fundraising” to describe the industry we’re all in. Of course, we’re as guilty as the next person: We use both terms in this book. But “fund development” seems to us bigger and better. It includes the concepts of process, activity over time, planning, growth, and change. Fund development makes us think about more than asking for the gift. And asking for the gift is one of the smallest portions of this work.")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("So here’s how Tom and I explain fund development:")]), _vm._v(" "), _c('div', {
    staticClass: "tx"
  }, [_vm._v("Philanthropy means voluntary action for the common good. Fund development is the essential partner of philanthropy. Fund development makes philanthropy possible by bringing together a particular cause and donors and prospects who are willing to invest in the cause. The goal is to acquire donors of time and money who stay with the charity. This is done through the process of relationship building. With the donor at the center, fund development nurtures loyalty and lifetime value, thus facilitating philanthropy. You know if your relationship building works because your retention rates rise and the lifetime value of your donors and volunteers increases.")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "h1"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ENDNOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c04_r1#Ref-en11",
      "id": "en11"
    }
  }, [_vm._v("1")]), _vm._v("   Leland R. Kaiser, Ph.D., is founder and president of Kaiser Consulting, a healthcare consulting firm located in Brighton, Colorado. Writer, lecturer, health policy analyst, and futurist, Dr. Kaiser sparks the imagination of audiences worldwide to change obsolete mind-sets. He made this statement at the April 2007 Kaiser Institute in Ponte Vedra, Florida.")]), _c('div', {
    staticClass: "end"
  }, [_c('a', {
    attrs: {
      "href": "#/aher_9781118044865_oeb_c04_r1#Ref-en12",
      "id": "en12"
    }
  }, [_vm._v("2")]), _vm._v("   Kay Sprinkel Grace and Alan L. Wendroff, "), _c('i', [_vm._v("High Impact Philanthropy: How Donors, Boards, and Nonprofit Organizations Can Transform Communities")]), _vm._v(" (Hoboken, NJ: John Wiley & Sons, 2001), p. 2.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbbcfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aher_9781118044865_oeb_c04_r1.vue
// module id = 93
// module chunks = 0